import { DashboardCategory } from '../../../mainDashboardv2/slice'
import { useMemo } from 'react'

export const useDashboardType = (widgetDashboardType: DashboardCategory) => {
  return useMemo(
    () => ({
      isPciDashboard: widgetDashboardType === DashboardCategory.compliance_pci_dashboard,
      isHipaaDashboard: widgetDashboardType === DashboardCategory.compliance_hipaa_dashboard
    }),
    [widgetDashboardType]
  )
}
